export default [
  {
    title: "Employee Management",
    customIcon: "CustomSVG",
    children: [
      {
        title: "Employee List",
        route: "custom-module",
        path: "/custom-module/custom-employee-list",
      },
    ],
  },
];
